export const errorMessage = {
  INVALID_USER: 'Usuário inválido',
  DISABLED_USER: 'Usuário Desabilitado',
  EMAIL_NOT_VERIFIED: 'Usuário inválido',
  INVALID_CREDENTIALS: 'Credênciais inválidas',
  NOT_FOUND: 'Não encontrado',
  DEFAULT: 'Tente novamente mais tarde.',
};
